import { defineStore } from 'pinia';
import { ref } from 'vue';

const useEventDataStore = defineStore('eventData', () => {
  const eventData = ref(null);
  const error = ref(null);
  const isLoadingEventData = ref(false);

  const setEventData = (data, error) => {
    eventData.value = data;
    error.value = error;
  };

  return { isLoadingEventData, eventData, error, setEventData };
});

export default useEventDataStore;
